module.exports = __webpack_public_path__ + "img/zc-coupon.6b5356cd.png";